export const NONE_RED_WINE_STYLES_LABELS = {
  dry: 'Dry',
  luscious: 'Luscious',
  medium: 'Medium',
  medium_dry: 'Medium Dry',
  medium_sweet: 'Medium Sweet',
  rich: 'Rich',
  sweet: 'Sweet',
  very_dry: 'Very Dry',
  very_sweet: 'Very Sweet',
} as Record<string, string>;

export const RED_WINE_STYLES_LABELS = {
  full: 'Full',
  light: 'Light',
  light_to_medium: 'Light to Medium',
  medium: 'Medium',
  medium_to_full: 'Medium to Full',
} as Record<string, string>;

export const NONE_RED_WINE_STYLES_ORDER = [
  'very_dry',
  'dry',
  'medium_dry',
  'medium',
  'medium_sweet',
  'sweet',
  'very_sweet',
  'rich',
  'luscious',
];

export const RED_WINE_STYLES_ORDER = [
  'light',
  'light_to_medium',
  'medium',
  'medium_to_full',
  'full',
];

export const DEFAULT_IMAGE_PDP = {
  height: 700,
  src: 'https://s7e5a.scene7.com/is/image/waitrose/BWS_Placeholder_PDP_product',
  width: 700,
};
export const DEFAULT_IMAGE_PLP = {
  height: 300,
  src: 'https://s7e5a.scene7.com/is/image/waitrose/BWS_Placeholder_PLP_product?extend=-140,-27,-138,-27',
  width: 352,
};
export const DEFAULT_IMAGE_ORDER_HISTORY = {
  height: 300,
  src: 'https://waitrose-prod.scene7.com/is/image/waitroseprod/BWS_Placeholder_Orderhistory_product?extend=-140,-27,-138,-27',
  width: 352,
};
export const DEFAULT_IMAGE_ORDER_SUMMARY = DEFAULT_IMAGE_ORDER_HISTORY;
